import { html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

import stylesParagraph from '../paragraph/paragraph.css.lit.ts';
import stylesLink from '../link/link.css.lit.ts';
import stylesButton from '../button/button.css.lit.ts';
import stylesList from '../list/list.css.lit.ts';
import stylesHeading from '../heading/heading.css.lit.ts';
import stylesBlockquote from '../blockquote/blockquote.css.lit.ts';
import stylesTable from '../table/table.css.lit.ts';
import stylesImage from '../image/image.css.lit.ts';
import stylesWysiwyg from './wysiwyg-ckeditor.css.lit.ts';
import {leavingSiteAlertHandler} from '../../utils/link.js';

export default class WYSIWYG_CKEDITOR extends OutlineElement {
  static styles = [
    super.styles,
    stylesParagraph,
    stylesLink,
    stylesButton,
    stylesList,
    stylesHeading,
    stylesBlockquote,
    stylesTable,
    stylesImage,
    stylesWysiwyg
  ];

  static get properties() {
    return {
      /**
       * HTML Markup to render
       */
      markup: { type: String },
    };
  }

  connectedCallback() {
    super.connectedCallback()

    this.shadowRoot.addEventListener('click', (event) => {
      const composedPathElement = event.composedPath().slice(0, 3)
      const isExternalLink = composedPathElement
        .filter(element => element.classList.contains('link--external'))
        .length > 0;

      if (isExternalLink && !leavingSiteAlertHandler()) {
        event.preventDefault()
      }
    });

    this.responsiveTables();
  }

  responsiveTables() {
    let tables = document.querySelectorAll('table');

    // Get column names
    let columNames = [];
    tables.forEach(table => 
      [...table.tHead.children[0].children].forEach(tr =>
        columNames.push(tr.innerText)
      )
    );
    
    // Set column names as data-label
    tables.forEach(table => 
      [...table.getElementsByTagName('tbody')[0].children].forEach(tr =>
        [...tr.children].forEach(function(td, i){
          td.setAttribute('data-label', columNames[i])
        })
      )
    );
  }

  render() {
    return html`
      <slot></slot>
    `;
  }
}
customElements.define('hf-wysiwyg-ckeditor', WYSIWYG_CKEDITOR)
